<router-outlet></router-outlet>


<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
       <ppl-member-wrapper-view [showAllTabs]="viewUserShowAllTabs"></ppl-member-wrapper-view>
    </ng-template>
</div>